module.exports = __webpack_public_path__ + "static/media/save.bcd3338c.svg";